// AI generation statuses
export const PROCESSING = 'PROCESSING';
export const COMPLETED = 'COMPLETED';
export const ERROR = 'ERROR';
